import React from 'react';
import pt from 'prop-types';

import View from 'components/view';
import { Form } from 'components/form';

import PartnerProfileForm from 'components/partners/profile-form';
import DirectoryListingCard from './directory-listing-card';

import './settings.scss';

export default class ProfileSettings extends React.PureComponent {
  static propTypes = {
    values: pt.object,
    apps: pt.array,
    errors: pt.object,
    edited: pt.bool,
    onChangePartnerName: pt.func,
    onChangeForm: pt.func,
    onSubmitForm: pt.func,
    onFormRef: pt.func,
    listingStatus: pt.string,
    onClickListingAction: pt.func,
    onClickListingCriteria: pt.func,
  };

  render() {
    const {
      values,
      apps,
      edited,
      onSubmitForm,
      onChangeForm,
      onChangePartnerName,
      onFormRef,
      errors,
      listingStatus,
      onClickListingAction,
      onClickListingCriteria,
    } = this.props;
    const canSaveDirectly =
      listingStatus === 'not_listed' || listingStatus === 'rejected';

    return (
      <div className="settings settings-profile">
        <Form
          ref={onFormRef}
          onSubmit={onSubmitForm}
          onChange={onChangeForm}
          values={values}
        >
          <View
            full
            headerTitle="Partner page"
            headerActions={
              canSaveDirectly
                ? [
                    {
                      label: 'Save changes',
                      type: edited ? 'default' : 'secondary disabled',
                      submit: true,
                    },
                  ]
                : []
            }
          >
            <fieldset className="full">
              <DirectoryListingCard
                status={listingStatus}
                edited={edited}
                onClickAction={onClickListingAction}
                onClickCriteria={onClickListingCriteria}
              />
            </fieldset>

            <PartnerProfileForm
              values={values}
              apps={apps}
              errors={errors}
              listingStatus={listingStatus}
              onChangePartnerName={onChangePartnerName}
            />
          </View>
        </Form>
      </div>
    );
  }
}
